import { render, staticRenderFns } from "./MinimalistCard.vue?vue&type=template&id=16d78d29&"
import script from "./MinimalistCard.vue?vue&type=script&lang=js&"
export * from "./MinimalistCard.vue?vue&type=script&lang=js&"
import style0 from "./MinimalistCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports